export default __webpack_public_path__ + "static/media/hot_shop.ee2736d4.png";